import { FaStar, FaRegStar, FaStarHalfAlt } from 'react-icons/fa';
import styled from 'styled-components';

const AverageRating = ({ reviews = [] }) => {
  // Safely calculate average rating
  const calculateAverage = () => {
    if (!reviews?.length) return 0;
    
    const validReviews = reviews.filter(review => 
      typeof review?.rating === 'number' && 
      !isNaN(review.rating) &&
      review.rating >= 0 &&
      review.rating <= 5
    );

    if (!validReviews.length) return 0;
    
    const sum = validReviews.reduce((total, review) => total + review.rating, 0);
    return sum / validReviews.length;
  };

  const averageRating = Math.min(5, Math.max(0, calculateAverage()));
  const fullStars = Math.floor(averageRating);
  const decimalPart = averageRating % 1;
  const showHalfStar = decimalPart >= 0.25 && decimalPart <= 0.75;
  const emptyStars = Math.max(0, 5 - fullStars - (showHalfStar ? 1 : 0));

  // Safely create star arrays
  const renderStars = () => {
    const stars = [];
    
    // Full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} />);
    }
    
    // Half star
    if (showHalfStar) {
      stars.push(<FaStarHalfAlt key="half" />);
    }
    
    // Empty stars
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} />);
    }
    
    return stars;
  };

  return (
    <RatingContainer>
      <NumericRating>
        {averageRating.toFixed(1)} / 5
      </NumericRating>
      
      <StarsContainer>
        {renderStars()}
      </StarsContainer>
      
      <ReviewCount>
        Average Rating<br />({reviews.length} Total Reviews)
      </ReviewCount>
    </RatingContainer>
  );
};
// Styled components
const RatingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px;
  border-radius: 8px;
  background-color: #f8f9fa;
  width: 200px;
  margin: 0 auto;
`;

const NumericRating = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #333;
`;

const StarsContainer = styled.div`
  color: #FFD700;
  font-size: 24px;
  display: flex;
  gap: 2px;
  margin: 4px 0;
`;

const ReviewCount = styled.div`
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 1.4;
`;

export default AverageRating;